import { useAuth } from './AuthProvider';

export function useAdminHeaders(): () => HeadersInit {
  const { token } = useAuth();

  return () => {
    const headers: HeadersInit = { 'Content-Type': 'application/json' };
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    return headers;
  };
}
